import {Pay} from 'com/gongxigames/math/core/game/Pay';
import {Timer} from '@gongxigames/framework/core';
import {AbstractReelsView} from '@gongxigames/framework/slot/modules/reels/AbstractReelsView';
import {ReelsModule} from '@gongxigames/framework/slot/modules/reels/ReelsModule';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {ReelsViewEvents} from '@gongxigames/framework/slot/modules/reels/ReelsViewEvents';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class ReelsQuickStopState extends ModuleState<AbstractReelsView, ReelsModule> {
    protected setupEvents(): void {
        this.setEventHandler(ReelsViewEvents.ALL_REELS_STOPPED, this.onAllReelsStopped.bind(this));
        this.setEventHandler(ReelsViewEvents.ALL_REEL_ANIMATIONS_FINISHED, this.onAllReelAnimationsFinished.bind(this));
        this.setEventHandler(WinPresentationEvents.INITIAL_ANIMATION_STARTED, this.onInitialAnimationStarted.bind(this));
    }

    public onEnterState(): void {
        this.emit(ReelsEvents.REELS_QUICKSTOP_STATE_ENTERED);
        this.view.isQuickStop = true;
        this.module.updateManager.add(
            new Timer(this.onTimedQuickStop.bind(this), this.view.reelConstants.QUICKSTOP_TIMER, true)
        );
    }

    public onLeaveState(): void {}

    protected onTimedQuickStop(): void {
        this.view.tryStoppingAllReels();
    }

    protected onAllReelAnimationsFinished(): void {
        this.module.isAllReelsStopped && this.onSpinEnded();
    }

    protected onAllReelsStopped(): void {
        if (this.module.isBlockingFlow) {
            this.module.isAllAnimationsFinished && this.onSpinEnded();
        } else {
            this.onSpinEnded();
        }
    }

    protected onSpinEnded(): void {
        this.module.gotoState(ReelsModule.BASIC_STATE);
        this.module.eventManager.emit(ReelsEvents.SPIN_ENDED);
    }

    // TODO should be act in WinState
    protected onInitialAnimationStarted(pays: Pay[]): void {
        this.view.hidePays(pays);
    }
}
